import { ElementRef, inject, Renderer2 } from '@angular/core';

export const toggleCssClass = (
  name: string,
  isEnabledFn: () => boolean,
  elRef = inject(ElementRef),
  renderer = inject(Renderer2),
) => {
  const add = () => renderer.addClass(elRef.nativeElement, name);
  const remove = () => renderer.removeClass(elRef.nativeElement, name);

  return {
    toggleIfCondition: () => (isEnabledFn() ? add() : remove()),
  };
};
